
import { Link, useLocation } from 'react-router-dom';

interface PageHeroProps {
  title: string;
  subtitle: string;
}

const PageHero = ({ title, subtitle }: PageHeroProps) => {
  const location = useLocation();

  const getBreadcrumbs = () => {
    const pathMap: { [key: string]: string } = {
      '/about': '当院について',
      '/services': 'ペット葬について',
      '/company': '会社概要',
      '/pricing': '料金表',
      '/contact': 'お問い合わせ',
    };

    return pathMap[location.pathname] || '';
  };

  return (
    <>
      <div className="relative h-[40vh] min-h-[300px] flex items-center justify-center mt-20 overflow-hidden">
        {/* Background Image */}
        <img
          src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/06de36d02de16f21b0ea31d5402adbeb.jpeg"
          alt="ペットたちの穏やかな風景"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        
        <div className="relative z-10 text-center px-4">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-white mb-3 sm:mb-4">
            {title}
          </h1>
          <p className="text-sm sm:text-base text-white/95 font-light">{subtitle}</p>
        </div>

        {/* Breadcrumbs */}
        <div className="absolute bottom-6 left-4 sm:left-8 flex items-center text-white text-sm z-10">
          <Link to="/" className="hover:text-pink-100 transition-colors">
            HOME
          </Link>
          <i className="ri-arrow-right-s-line mx-2"></i>
          <span className="font-medium">{getBreadcrumbs()}</span>
        </div>
      </div>
    </>
  );
};

export default PageHero;
